import React from 'react';
import clsx from 'clsx';
import { reFetchConfig } from '@/hooks/paging';
import PanelContainer from '@/components/wrappers/PanelContainer';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const AuditsPanelContainer = ({
  category,
  children,
  className,
  code,
  compact,
  onChange,
  url,
}) => {
  const state = Selectors.useAuditsPanelContainer({ category, code });
  const config = compact ? reFetchConfig(state.audits, state) : undefined;
  Fetch.useFetchAudits({ category, code }, state.readStatus, config);

  return (
    <PanelContainer
      canAccess={state.canRead}
      exists={state.exists}
      name={state.name}
      onChange={onChange}
      readErrors={state.readErrors}
      url={url}
    >
      <div className={clsx('aridhia-audits-panel-container', className)}>
        { children }
      </div>
    </PanelContainer>
  );
};

export default AuditsPanelContainer;
